// Environment variable mapping
// Rsbuild requires direct property access (not dynamic) for build-time replacement
// Maps to PUBLIC_* environment variables
const ENV_MAP = {
  API_URL: import.meta.env.PUBLIC_API_URL,
  HOST: import.meta.env.PUBLIC_HOST,
  ENV: import.meta.env.PUBLIC_ENV,
  SENTRY_DSN: import.meta.env.PUBLIC_SENTRY_DSN,
  STRIPE_PUBLISHABLE_KEY: import.meta.env.PUBLIC_STRIPE_PUBLISHABLE_KEY,
  INTERCOM_APP_ID: import.meta.env.PUBLIC_INTERCOM_APP_ID,
  METABASE_URL: import.meta.env.PUBLIC_METABASE_URL,
  ROLLBAR_ACCESS_TOKEN: import.meta.env.PUBLIC_ROLLBAR_ACCESS_TOKEN,
  ENABLE_ROLLBAR: import.meta.env.PUBLIC_ENABLE_ROLLBAR,
  ENABLE_SENTRY_ERRORS: import.meta.env.PUBLIC_ENABLE_SENTRY_ERRORS,
  EXPERIMENTATION_SAVINGS: import.meta.env.PUBLIC_EXPERIMENTATION_SAVINGS,
  JIRA_TICKETING_ENABLED: import.meta.env.PUBLIC_JIRA_TICKETING_ENABLED,
} as const;

// Helper function to get environment variable
const getEnv = (key: keyof typeof ENV_MAP): string | undefined => {
  return ENV_MAP[key];
};

// Hack for e2e tests to run on megatenantdnd tenant with production backend
export const API_URL = window.location.host.includes("megatenantdnd")
  ? "https://api.getaltimate.com"
  : getEnv("API_URL");

const ENV_VALUE = getEnv("ENV");
console.log(ENV_VALUE);

// Log environment variables for debugging (only in development/local environments)
if (ENV_VALUE === "development" || ENV_VALUE === "local" || ENV_VALUE === "staging") {
  console.log("🔧 Environment Variables:");
  console.table({
    PUBLIC_API_URL: getEnv("API_URL") || "(not set)",
    PUBLIC_HOST: getEnv("HOST") || "(not set)",
    PUBLIC_ENV: getEnv("ENV") || "(not set)",
    PUBLIC_SENTRY_DSN: getEnv("SENTRY_DSN") || "(not set)",
    PUBLIC_STRIPE_PUBLISHABLE_KEY: getEnv("STRIPE_PUBLISHABLE_KEY") || "(not set)",
    PUBLIC_INTERCOM_APP_ID: getEnv("INTERCOM_APP_ID") || "(not set)",
    PUBLIC_METABASE_URL: getEnv("METABASE_URL") || "(not set)",
    PUBLIC_ROLLBAR_ACCESS_TOKEN: getEnv("ROLLBAR_ACCESS_TOKEN") || "(not set)",
    PUBLIC_ENABLE_ROLLBAR: getEnv("ENABLE_ROLLBAR") || "(not set)",
    PUBLIC_ENABLE_SENTRY_ERRORS: getEnv("ENABLE_SENTRY_ERRORS") || "(not set)",
    PUBLIC_EXPERIMENTATION_SAVINGS: getEnv("EXPERIMENTATION_SAVINGS") || "(not set)",
    PUBLIC_JIRA_TICKETING_ENABLED: getEnv("JIRA_TICKETING_ENABLED") || "(not set)",
    "API_URL (computed)": API_URL || "(not set)",
  });
}

// Warn if API_URL is not set
if (!API_URL || API_URL === "undefined") {
  console.error(
    "CRITICAL: PUBLIC_API_URL is not set! API calls will fail. Please configure environment variables."
  );
}

export const HOST = getEnv("HOST");
export const SENTRY_DSN = getEnv("SENTRY_DSN");
export const ENV = ENV_VALUE;
export const STRIPE_PUBLISHABLE_KEY = getEnv("STRIPE_PUBLISHABLE_KEY");
export const INTERCOM_APP_ID = getEnv("INTERCOM_APP_ID");
export const EXPERIMENTATION_SAVINGS = getEnv("EXPERIMENTATION_SAVINGS");
export const JIRA_TICKETING_ENABLED = getEnv("JIRA_TICKETING_ENABLED");

export const ENABLE_SENTRY_ERRORS =
  getEnv("ENABLE_SENTRY_ERRORS") === "true" || ENV === "production";
export const METABASE_URL = getEnv("METABASE_URL");

export const ROLLBAR_ACCESS_TOKEN = getEnv("ROLLBAR_ACCESS_TOKEN");
export const ENABLE_ROLLBAR = getEnv("ENABLE_ROLLBAR") === "true";
